import React from "react";
import PillarCard from "./PillarCard";
import "../App.css";

/**
 * Seção genérica de "cards com ícone, título e texto" (usa PillarCard).
 * Reaproveitada na Home ("Nossos Pilares de Atuação") e em Serviços
 * ("Soluções Completas para o seu Negócio"), cada uma passando seus
 * próprios dados via props.
 *
 * Props:
 * - id: string (opcional, para permitir âncoras do tipo #id)
 * - eyebrow: string (opcional, pequeno rótulo acima do título)
 * - title: string
 * - text: string (opcional, parágrafo abaixo do título)
 * - items: [{ icon, title, text }]
 */
export default function PillarsSection({ id, eyebrow, title, text, items }) {
  return (
    <section id={id} className="pillars-section">
      <div className="pillars-section__blob" aria-hidden="true" />

      <div className="pillars-section__container">
        <div className="pillars-section__header">
          {eyebrow && <span className="pillars-section__eyebrow">{eyebrow}</span>}
          <h2 className="pillars-section__title">{title}</h2>
          {text && <p className="pillars-section__text">{text}</p>}
        </div>

        <div className="pillars-section__grid">
          {items.map((item, index) => (
            <PillarCard key={item.title} icon={item.icon} title={item.title} text={item.text} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}
